import { Component, OnInit } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from 'projects/common/src/app/interfaces/table/table-large-column-config';
import { LanguageService } from 'projects/common/src/app/services/parameters/language/language.service';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportCartirProductionService } from '../../services/report-cartir-production.service';

@Component({
  selector: 'app-report-cartir-vs-production',
  templateUrl: './report-cartir-vs-production.component.html',
  styleUrls: ['./report-cartir-vs-production.component.scss'],
})
export class ReportCartirVsProductionComponent implements OnInit {
  public filterConfig: IFilterConfig;
  public params: IOutputFilter;
  public tableConfig: ITableConfig;
  public tableData: any;
  public hasData: boolean;
  public message: string;
  public systemError: string;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;
  constructor(
    private layoutConfigService: LayoutConfigService,
    private cartirVsProductionService: ReportCartirProductionService,
    private tableConfigService: TableConfigService,
    private languageService: LanguageService,
    private datePipe: DatePresentationPipe,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.hasData = false;
    this.message = '';
    this.disabledExcelBtn = false;
  }

  public ngOnInit(): void {
    this.initLayoutConfig();
    this.initDefautlFilter();
  }

  /** Init Layout Report */
  public initLayoutConfig(): void {
    const configLayout: ILayoutConfig = {
      title: 'reports',
      subtitle: 'cartir-vs-production',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(configLayout);
  }

  /** Init Default filter */
  public initDefautlFilter(): void {
    this.filterConfig = {
      dates: { required: true },
      shift: { required: true },
      allMine: { required: true },
      cleanButton: true,
    };
  }

  /**
   * Fill table report cartir vs production
   *
   * @param selectedFilter
   */
  public fillTableCartirProduction($event): void {
    this.params = {
      startDate: $event.startDate,
      endDate: $event.endDate,
      shiftId: $event.shiftId,
      mineId: $event.zoneId,
    };
    this.filterConfig.isLoading = true;
    this.tableData = [];
    this.cartirVsProductionService.GetReportCartirVsProduction(this.params).then((result) => {
      for (const item of result) {
        this.tableData.push({
          shiftName: item.shiftName,
          sector: item.sector,
          streetName: item.streetName,
          extractionPoint: item.extractionPoint,
          pailQuantity: item.pailQuantity,
          additionalPailQuantity: item.additionalPailQuantity,
          taskStart: item.taskStart,
          lastStatus: item.lastStatus,
          reporterName: item.reporterName,
          lastStatusAt: item.lastStatusAt,
          loopDone: item.loopDone,
          lastCondition: item.lastCondition,
          lastConditionAt: item.lastConditionAt,
        });
      }

      if (result.length) {
        this.setTableConfigReport(this.tableData);
        this.filterConfig.isLoading = false;
        this.message = '';
        this.hasData = true;
      } else {
        this.hasData = false;
        this.message = this.languageService.message('m034');
        this.filterConfig.isLoading = false;
      }
    });
    const filters = {
      reports: 'report-cartir-vs-production',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * Set table config report cartir vs production
   */
  public setTableConfigReport(tableData: any): void {
    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'shiftName', isLargeColumn: true, flexGrow: 0.8, customPadding: '6px 0px 0px 8px' },
      { field: 'sector', isLargeColumn: true, flexGrow: 0.8, customPadding: '6px 0px 0px 3px' },
      { field: 'streetName', isLargeColumn: true, flexGrow: 0.8, customPadding: '6px 0px 0px 3px' },
      { field: 'extractionPoint', isLargeColumn: true, flexGrow: 0.8, customPadding: '6px 0px 0px 3px' },
      { field: 'pailQuantity', isLargeColumn: true, flexGrow: 1, customPadding: '6px 0px 0px 3px' },
      { field: 'additionalPailQuantity', isLargeColumn: true, flexGrow: 1, customPadding: '6px 0px 0px 3px' },
      { field: 'reporterName', isLargeColumn: true, flexGrow: 1.5, customPadding: '6px 0px 0px 3px' },
      { field: 'taskStart', isLargeColumn: true, flexGrow: 1, customPadding: '6px 0px 0px 3px' },
    ];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      replaceColumnName: [
        { prevName: 'zoneName', newName: 'zone' },
        { prevName: 'pailQuantity', newName: 'shelves' },
        { prevName: 'streetName', newName: 'street' },
        { prevName: 'extractionPoint', newName: 'ditch' },
        { prevName: 'additionalPailQuantity', newName: 'remnant-shelves' },
        { prevName: 'taskStart', newName: 'cartir-start' },
        { prevName: 'reporterName', newName: 'reported by' },
        { prevName: 'lastStatusAt', newName: 'date' },
        { prevName: 'lastCondition', newName: 'last-condition' },
        { prevName: 'lastConditionAt', newName: 'date' },
        { prevName: 'loopDone', newName: 'loops-made' },
      ],
      sortables: true,
      customLargeColumns,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns: ['machineId', 'machineTypeId', 'zoneId', 'shiftId'],
      dateConfig: [
        { field: 'taskStart', format: 'date-time' },
        { field: 'lastStatusAt', format: 'date-time' },
        { field: 'lastConditionAt', format: 'date-time' },
      ],
      customLargeColumns,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset }), 0);
  }

  /**
   * Download file report
   */
  public downloadExcelReport(): void {
    const selectRangeDate = {
      startDate: this.datePipe.transform(this.params.startDate),
      endDate: this.datePipe.transform(this.params.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;

    this.cartirVsProductionService.DownloadReportCartirProductionExcel(this.params).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'cartir-vs-production', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
